import { render } from "./GemIcon.vue?vue&type=template&id=008d0c6c"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/GemIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "008d0c6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('008d0c6c', __exports__)) {
    api.reload('008d0c6c', __exports__)
  }
  
  module.hot.accept("./GemIcon.vue?vue&type=template&id=008d0c6c", () => {
    api.rerender('008d0c6c', render)
  })

}


export default __exports__